import { Form, Modal, notification } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  getSubject,
  updateSubject,
  getSubjects,
} from "store/slices/subjectsSlice";
import SubjectForm from "./subject-form";

const EditSubjectModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();

  const { isModalOpen, modalType, modalProps } = useSelector(
    (state) => state?.modals
  );
  const { subject, loading } = useSelector((state) => state?.subjects);

  const open = isModalOpen && modalType === "edit_subject";
  const subjectId = modalProps?.subjectId;

  useEffect(() => {
    if (open && subjectId) {
      dispatch(getSubject(subjectId));
    }
  }, [dispatch, open, subjectId]);

  useEffect(() => {
    if (subject) {
      form?.setFieldsValue({
        title: subject?.title,
      });
    }
  }, [form, subject]);

  const onSubmit = async (values) => {
    try {
      await dispatch(
        updateSubject({
          id: subjectId,
          data: values,
        })
      )?.unwrap();
      await dispatch(getSubjects())?.unwrap();
      notification?.success({
        message: t("subjects.crud.form.update.success"),
      });
      onClose();
    } catch (error) {
      notification?.error({
        message: t("subjects.crud.form.update.error"),
        description: error?.message,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={t("subjects.crud.edit")}
      open={open}
      onCancel={onClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
    >
      <SubjectForm form={form} onSubmit={onSubmit} loading={loading} />
    </Modal>
  );
};

export default EditSubjectModal;
